import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Face from "@/model/face";
import faceApi from "@/api/faceApi";

@Module({ namespaced: true })
export default class FaceModule extends VuexModule {
  public faces: Face[] = null;
  @Mutation
  setFaces(faces: Face[]): void {
    this.faces = faces;
  }
  @Action({ rawError: true })
  async fetchFaces(): Promise<any> {
    const faces = await faceApi.index();
    this.context.commit("setFaces", faces);
  }
  @Action({ rawError: true })
  updateFaces(faces: Face[]): void {
    this.context.commit("setFaces", faces);
  }

  get getFaces(): Face[] {
    return this.faces;
  }
}
